import { Meteor } from 'meteor/meteor';
import { get } from 'lodash';

/**
 * Gets the deploy environment from the application private settings.
 * Only gets the variable when it's run on server side.
 *
 * @returns {string} The deploy environment or an empty string if on client side
 * or if an error ocurred.
 */
export const getDeployEnv = () =>
  Meteor.isServer ? get(Meteor, 'settings.private.config.deploymentEnv', '') : '';

/**
 * Checks if the deploy environment is the ground station.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {boolean} True if in ground station deployment or false otherwise.
 */
export const isGroundStation = deployEnv => deployEnv === 'ias-gs';

/**
 * Checks if the deploy environment is the web page.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {boolean} True if in web page deployment or false otherwise.
 */
export const isWeb = deployEnv => ['ias-web', 'gmv', 'maps'].includes(deployEnv);

/**
 * Checks if the deploy environment is Ipsilum Aerial Solution.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {boolean} True if in web page deployment or false otherwise.
 */
export const isIAS = deployEnv => ['ias-web', 'ias-gs'].includes(deployEnv);

/**
 * Checks if the deploy environment is GeoMotionVideo.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {boolean} True if in GeoMotionVideo deployment or false otherwise.
 */
export const isGeoMotionVideo = deployEnv => deployEnv === 'gmv';

/**
 * Checks if the deploy environment is Maps.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {boolean} True if in Maps deployment or false otherwise.
 */
export const isMaps = deployEnv => deployEnv === 'maps';

/**
 * Checks if the deploy environment is BoilerPlate.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {boolean} True if in BoilerPlate deployment or false otherwise.
 */
export const isBoilerPlate = deployEnv => deployEnv === 'boilerplate';

/**
 * Checks if the deploy environment is Luminarias.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {boolean} True if in Luminarias deployment or false otherwise.
 */
export const isLuminarias = deployEnv => deployEnv === 'luminarias';

/**
 * Gets the redirection path given the deploy environment.
 *
 * @param {string} deployEnv - The deploy env.
 * @returns {string} The redirection path for the deploy environment or an empty string if none specified.
 */
export const getRedirectPath = deployEnv => {
  let redirectTo = '';
  switch (true) {
    case isIAS(deployEnv):
    case isGeoMotionVideo(deployEnv):
      redirectTo = '/projects';
      break;

    case isMaps(deployEnv):
      redirectTo = '/layers';
      break;

    case isBoilerPlate(deployEnv):
      redirectTo = '/documents';
      break;

    case isLuminarias(deployEnv):
      redirectTo = '/map';
      break;

    default:
      break;
  }
  return redirectTo;
};
